<template>
  <v-container small>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card elevation="0">
          <v-card-title class="text-wrap">
            <div class="display-1 font-weight-light text--primary text-break">
              Need some help?
            </div>
          </v-card-title>
          <v-card-text>
            <retrievalChoice />
          </v-card-text>
        </v-card>
        <v-card-actions>
          <v-row class="px-2">
            <v-col cols="12" md="6">
              <v-btn outlined block :href="home">cancel</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-col>
    </v-row>
    <v-dialog v-model="generalError" persistent max-width="350" app>
      <v-card>
        <v-card-title class="headline pink--text accent-4"
          >{{ errorType }} Retrieval Error</v-card-title
        >
        <v-card-text>
          An error occurred while trying to retrieve your {{ errorType }}.
          Please try again or contact Client Services for further assistance.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="clearError">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import retrievalChoice from "@/components/retrievalChoice";

export default {
  name: "UsernamePassword",
  components: {
    retrievalChoice,
  },

  data: () => ({
    step: 1,
    retrievalSelction: undefined,
    generalError: false,
    errorType: "",
  }),
  computed: {
    home() {
      return this.$store.getters.getHome;
    },
  },
  methods: {
    clearError() {
      this.generalError = false;
      this.errorType = "";
    },
    errorPresent(value) {
      this.generalError = true;
      this.errorType = value;
    },
    changeStep(value) {
      this.step = value;
    },
  },
  created: function () {
    this.$vuetify.theme.dark = false;
  },
};
</script>
